import { useState, useEffect } from 'react';
import { API, Auth } from 'aws-amplify';

export const useFetchGenres = () => {
  const [data, setData] = useState<string[]>();
  const [error, setError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(true);
    setError(false);

    const fetchData = async (): Promise<void> => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const requestInfo = {
          headers: {
            Authorization: token
          }
        };
        const res = await API.get('mappingApi', '/getSpotifyGenres', requestInfo);
        setData(res['genres']);
      } catch (error) {
        console.log(error);
        setError(true);
      }
      setIsLoading(false);
    };

    fetchData();
  }, []);

  return {
    data,
    error,
    isLoading
  };
};
